'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import I18n from 'I18n';

const MissingContentError = ({
  className
}) => /*#__PURE__*/_jsxs(UIErrorMessage, {
  className: classNames('missing-content-error', className),
  "data-test-id": "missing-content-error",
  type: "notFound",
  width: "100%",
  children: [/*#__PURE__*/_jsx("p", {
    children: I18n.text('learningCenter.errors.missingContent.subheading')
  }), /*#__PURE__*/_jsx(UIRouterButton, {
    to: "/",
    children: I18n.text('learningCenter.errors.missingContent.button')
  })]
});

MissingContentError.propTypes = {
  className: PropTypes.string
};
export default MissingContentError;